type FeedbackMessagesProps = {
	error: string | null;
	success: boolean;
	fieldErrors: Record<string, string[]>;
};

export const FeedbackMessages = ({
	error,
	success,
	fieldErrors,
}: FeedbackMessagesProps) => {
	const hasError: boolean = error !== null;
	const hasSuccess: boolean = success === true;
	const hasFieldErrors: boolean = Object.keys(fieldErrors).length > 0;

	if (!(hasError || hasSuccess)) {
		return null;
	}

	return (
		<>
			{hasError ? (
				<div className="rounded-lg border border-red-200 bg-red-50 p-4">
					<p className="font-medium text-red-800 text-sm">{error}</p>

					{hasFieldErrors ? (
						<ul className="mt-2 list-inside list-disc space-y-1">
							{Object.entries(fieldErrors).map(([field, errors]) => (
								<li className="text-red-700 text-sm" key={field}>
									<span className="font-medium">{field}:</span>{" "}
									{errors.join(", ")}
								</li>
							))}
						</ul>
					) : null}
				</div>
			) : null}

			{hasSuccess ? (
				<div className="rounded-lg border border-green-200 bg-green-50 p-4">
					<p className="text-green-800 text-sm">Pergunta criada com sucesso!</p>
				</div>
			) : null}
		</>
	);
};
